var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdDirectBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1300,
    height: 493,
    viewBox: "0 0 1300 493",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3498_2019",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1300,
    height: 493
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1300,
    height: 493,
    rx: 20,
    fill: "#111111"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3498_2019)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3498_2019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-70 337.417C-70 241.89 -67.3864 242.673 -45.908 195.453C-10.8859 118.459 -62.6506 61.6086 170.721 195.453C404.092 329.298 24.8283 601.735 -24.0251 477.219C-45.5281 422.413 -70 432.944 -70 337.417Z",
    fill: "url(#paint0_linear_3498_2019)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3498_2019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1233.72 371.568C1128 394.203 1047.86 359.475 1015.54 298.062C976.959 224.741 1056.34 194.022 1090.76 105.93C1172.13 -102.323 1292.92 110.575 1341.59 151.215C1413.01 210.856 1336.54 349.556 1233.72 371.568Z",
    fill: "url(#paint1_linear_3498_2019)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3498_2019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1047.49 246.018C927.392 199.474 960.532 54.6706 1087.4 -35.8346C1173.67 -97.3782 1312.61 -70.2327 1332.8 -1.57683C1352.99 67.079 1376.65 104.218 1272.63 134.803C1168.6 165.388 1174.45 274.171 1047.49 246.018Z",
    fill: "url(#paint2_linear_3498_2019)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3498_2019",
    x: -290,
    y: -105,
    width: 756,
    height: 834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 110,
    result: "effect1_foregroundBlur_3498_2019"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3498_2019",
    x: 825.205,
    y: -164.061,
    width: 724.281,
    height: 722.584,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90,
    result: "effect1_foregroundBlur_3498_2019"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3498_2019",
    x: 832.83,
    y: -210.173,
    width: 657.527,
    height: 600.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 70,
    result: "effect1_foregroundBlur_3498_2019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3498_2019",
    x1: 157,
    y1: 359,
    x2: 102.916,
    y2: 157.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9FE70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3498_2019",
    x1: 1353.13,
    y1: 257.17,
    x2: 1008.15,
    y2: 231.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9FE70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3498_2019",
    x1: 1237.37,
    y1: -41.1998,
    x2: 925.628,
    y2: 218.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BD1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAFF1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdDirectBackground);
export default __webpack_public_path__ + "static/media/AdDirectBackground.8e058e96b60178d97df53fbcd332ac2b.svg";
export { ForwardRef as ReactComponent };